import { render, staticRenderFns } from "./contribution_event_base.vue?vue&type=template&id=4e2697f2"
import script from "./contribution_event_base.vue?vue&type=script&lang=js"
export * from "./contribution_event_base.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports